import type { BackgroundProgress, SlideImageProgress } from "@vida/surf-core";

type Props = {
  activity: string | null;
  progress: BackgroundProgress | SlideImageProgress | null;
};

export function EditorActivityFooter({ activity, progress }: Props) {
  if (!activity && !progress) return null;

  return (
    <footer className="editor-activity">
      {progress && (
        <span>
          Slide {progress.index + 1}/{progress.total} — {progress.status}
          {progress.message ? `: ${progress.message}` : ""}
        </span>
      )}
      {activity && <span>{activity}</span>}
    </footer>
  );
}
